import { combineReducers } from "redux";

// Slices
import assessmentSlice from "./assessment";
import reportSlice from "./report";

// Re-export
export * from "./assessment";
export * from "./report";

export * from "./paceSlice.types";

const paceReducers = combineReducers({
    assessment: assessmentSlice,
    report: reportSlice,
});

export default paceReducers;
